import { streamText } from "ai";
import { ollama } from "ollama-ai-provider";

export class AIService {
  private static instance: AIService;
  private isConnected: boolean = false;
  private models: any[] = [];

  private constructor() {}

  static getInstance(): AIService {
    if (!AIService.instance) {
      AIService.instance = new AIService();
    }
    return AIService.instance;
  }

  async checkConnection(): Promise<boolean> {
    try {
      const response = await fetch("http://localhost:11434/api/tags");
      this.isConnected = response.ok;
      return this.isConnected;
    } catch (error) {
      console.error("Ollama connection error:", error);
      this.isConnected = false;
      return false;
    }
  }

  async listModels(): Promise<any[]> {
    if (!this.isConnected) {
      await this.checkConnection();
    }

    try {
      const response = await fetch("http://localhost:11434/api/tags");
      if (response.ok) {
        const data = await response.json();
        this.models = data.models || [];
        return this.models;
      }
      return [];
    } catch (error) {
      console.error("Error listing models:", error);
      return [];
    }
  }

  // Streaming generate function using fetch and ReadableStream
  async streamResponse(
    model: string,
    messages: { role: "user" | "assistant"; content: string }[],
    options: {
      temperature?: number;
      system?: string;
    } = {}
  ) {
    if (!this.isConnected) {
      throw new Error("Not connected to Ollama");
    }

    const { temperature = 0.7, system } = options;
    // Build the prompt from messages
    const prompt = messages
      .map((m) => `${m.role === "user" ? "User" : "Assistant"}: ${m.content}`)
      .join("\n");
    const systemPrompt = system || "You are a helpful AI assistant.";

    // POST to /api/generate with streaming enabled
    const response = await streamText({
      model: ollama(model),
      prompt,
      system: systemPrompt,
      temperature,
    });

    if (!response.textStream) throw new Error("No response body for streaming");
    const reader = response.textStream.getReader();
    const decoder = new TextDecoder();

    // Async generator for streaming text
    async function* streamChunks() {
      let done = false;
      let fullText = "";
      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        if (value) {
          // Fix: TextDecoder.decode expects a BufferSource (e.g., Uint8Array), not a string
          const chunk = decoder.decode(value as unknown as Uint8Array);
          // Ollama streams JSON lines, parse each line
          for (const line of chunk.split("\n")) {
            if (!line.trim()) continue;
            try {
              const data = JSON.parse(line);
              if (data.response) {
                fullText += data.response;
                yield data.response;
              }
            } catch (e) {
              // Ignore parse errors
            }
          }
        }
      }
    }

    return { textStream: streamChunks() };
  }
}

export const aiService = AIService.getInstance();
